import { Component } from '@angular/core';
import { UtilityHelper } from '../../../../core/helper/utility-helper';
import {
  RouterLink,
  RouterModule,
  Router,
  ActivatedRoute,
} from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormsModule } from '@angular/forms';
import { WebService } from '../../../../core/services/web-service/web.service';
import { environment } from '../../../../../environments/environment';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  MatPaginator,
  MatPaginatorModule,
  PageEvent,
} from '@angular/material/paginator';
import { AuthService } from '../../../../core/services/authentication/auth.service';
import { Subscription } from 'rxjs';
import { AppConstants } from '../../../../core/constant/app.constant';
@Component({
  selector: 'app-category-wise-product-list',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatPaginatorModule,
    MatPaginator,
    RouterModule,
    MatTooltipModule,
    RouterLink
  ],
  templateUrl: './category-wise-product-list.component.html',
  styleUrl: './category-wise-product-list.component.scss',
})
export class CategoryWiseProductListComponent {
  lastSegment: string | null = null;
  isLoading: boolean = true;
  searchData: string = '';
  DataList: any[] = [];
  totalPages: number = 0;
  imageBaseUrl = environment.imageBaseUrl;
  domiImageBaseUrl = environment.domiImageBaseUrl;
  categoryId: any;
  subCategoryId: any;
  ResponseData: any;
  attributeTerm: any;
  isCartLoading: boolean = false;
  isModalOpen: boolean = false;
  product: any = '';
  attrVariationDataList: any;
  variationsCodeToFilter = '';
  variations: any = '';
  price: any = '';
  variant_id: any = '';
  filteredVariationData: any = '';
  filteredVariation: any = '';
  firstVariationImagePath: any = '';
  termIdsToSelect: any = '';
  quantity = 1;
  activeTerms: { [key: number]: number } = {};
  pagination = {
    totalElements: 0,
    page: 0,
    size: 15,
  };
  payload: any = '';

  currentUserId: any = null;
  siteBarshowHide = false;
  priceRanges = [
    { label: 'Under Rs 50', value: '0-50' },
    { label: 'Rs 51 to Rs 100', value: '51-100' },
    { label: 'Rs 101 to Rs 200', value: '101-200' },
    { label: 'Rs 201 to Rs 500', value: '201-500' },
    { label: 'Rs 500 to Rs 1000', value: '500-1000' },
    { label: 'More than Rs 1000', value: '1000-2000000000' },
  ];

  constructor(
    private fb: FormBuilder,
    private webService: WebService,
    private utility: UtilityHelper,
    private router: Router,
    private AuthService: AuthService,
    private route: ActivatedRoute
  ) {}
  private subscription!: Subscription;
  ngOnInit() {
    this.route.params.subscribe((params) => {
      const encryptedCatId = params['categoryId'];
      this.categoryId = parseInt(
        this.utility.decryptLinkParams(encryptedCatId)
      );
      const encryptedSubCatId = params['subCategoryId'];
      const subCategoryId = parseInt(
        this.utility.decryptLinkParams(encryptedSubCatId)
      );
      if (subCategoryId == 0) {
        this.subCategoryId = '';
      } else {
        this.subCategoryId = parseInt(
          this.utility.decryptLinkParams(encryptedSubCatId)
        );
      }

      this.payload = {
        pageIndex: 0,
        pageSize: this.pagination.size,
        sortBy: '',
        searchBy: '',
        sortingOrder: '',
        status: 1,
        categoryId: this.categoryId,
        subCategoryId: this.subCategoryId,
        sortByProduct: '',
        userId: '',
        warehouse_id: 1,
      };
    });
    this.getCurrentUser();

    this.fetchAllProduct();
    this.getSubCatList();
    this.getAttrTermData();
    this.subscription = this.webService.cartItemRemoved$.subscribe((cartId) => {
      this.DataList = this.DataList.map((product: any) => {
        if (product.id == cartId) {
          product.cart = false;
        }
        return product;
      });
    });
  }
  // ngOnDestroy(): void {
  //   this.subscription.unsubscribe();
  // }
  getCurrentUser(): void {
    const token = localStorage.getItem(AppConstants.localStorage.authToken);
    if (token){
      this.currentUserId = this.AuthService.userId;
    }
  }
  encryptId(id: any): string {
    return this.utility.encryptLinkParams(id.toString());
  }

  navigateToProductDetail(
    product: any,
    productId: string,
    dynamicSlug: string,
    variationsCode: string
  ): void {
    localStorage.setItem(
      AppConstants.localStorage.categoryId,
      JSON.stringify(product.category_id)
    );
    const encryptedId = this.encryptId(productId);
    this.router.navigate([
      `product/${dynamicSlug}/${variationsCode}`,
      encryptedId,
    ]);
  }
  selectedRanges: string = '';
  sortByProduct: any = '';
  sortByHeading: string = '';
  onPriceRangeChange(event: Event, value: string) {
    const checkbox = event.target as HTMLInputElement;

    if (checkbox.checked) {
      this.selectedRanges += this.selectedRanges ? `,${value}` : value;
    } else {
      const rangesArray = this.selectedRanges.split(',');
      this.selectedRanges = rangesArray
        .filter((range) => range !== value)
        .join(',');
    }
    this.fetchAllProduct();
  }
  selectedFilters: { [key: string]: string[] } = {};
  onCheckboxChange(attributeId: number, termId: number, event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    const isChecked = checkbox.checked;

    const attrIdStr = attributeId.toString();
    if (isChecked) {
      if (!this.selectedFilters[attrIdStr]) {
        this.selectedFilters[attrIdStr] = [];
      }
      if (!this.selectedFilters[attrIdStr].includes(termId.toString())) {
        this.selectedFilters[attrIdStr].push(termId.toString());
      }
    } else {
      this.selectedFilters[attrIdStr] = this.selectedFilters[attrIdStr].filter(
        (id) => id !== termId.toString()
      );
      if (this.selectedFilters[attrIdStr].length === 0) {
        delete this.selectedFilters[attrIdStr];
      }
    }
    this.fetchAllProduct();
  }
  sortByProductData(sortType: string): void {
    this.sortByProduct = sortType;
    if (sortType === 'low_to_high') {
      this.sortByHeading = 'Low to High';
    } else if (sortType === 'High to Low') {
      this.sortByHeading = '';
    } else if (sortType === 'most_popular') {
      this.sortByHeading = 'Most Popular';
    }
    this.fetchAllProduct();
  }
  fetchAllProduct() {
    this.isLoading = true;
    this.payload.searchBy = this.searchData;
    this.payload.pageIndex = this.pagination.page;
    this.payload.pageSize = this.pagination.size;
    this.payload.userId = this.currentUserId;
    this.payload.verientdata = this.selectedFilters;
    (this.payload.minMaxPrice = this.selectedRanges),
      (this.payload.sortByProduct = this.sortByProduct),
      this.webService.productList(this.payload).subscribe({
        next: (res: any) => {
          if (res.status === 200 && res.data) {
            this.DataList = res.data.content;
            this.pagination.totalElements = res.data.totalElements;
            this.totalPages = res.data.totalPages;
          } else {
            this.DataList = [];
          }
          this.isLoading = false;
        },
        error: (error: any) => {
          this.isLoading = false;
          this.utility.toastAlert(
            'error',
            error.message || 'An error occurred'
          );
        },
      });
  }
  onPageChange(page: number) {
    if (page >= 0 && page < this.totalPages) {
      this.pagination.page = page;
      this.fetchAllProduct();
    }
  }

  addToCartData(
    productId: any,
    quantity: any,
    currentPrice: any,
    product_type: any,
    variant_id: any
  ): void {
    if (this.currentUserId) {
      const payload = {
        user_id: this.currentUserId,
        product_id: productId,
        quantity: quantity,
        product_type: product_type,
        variant_id: variant_id,
        currentPrice: currentPrice,
      };
      this.isCartLoading = true;

      this.webService.addToCart(payload).subscribe({
        next: (res: any) => {
          if (res.status === 200 && res.data) {
            this.webService.triggerReload();
            this.DataList = this.DataList.map((product: any) => {
              if (product.id === productId) {
                product.cart = true;
              }
              return product;
            });
            // this.fetchAllProduct();
            this.isModalOpen = false;
            this.utility.toastAlert('success', res.message);
          } else {
            this.utility.toastAlert('error', res.message);
          }
          this.isCartLoading = false;
        },
        error: (error: any) => {
          this.isCartLoading = false;
          this.utility.toastAlert(
            'error',
            error.message || 'An error occurred'
          );
        },
      });
    } else {
      this.router.navigate(['/users/account/sign-in']);
    }
  }

  onSearch() {
    this.pagination.page = 0;
    this.fetchAllProduct();
  }
  addToWishlist(id: any): void {
    if (this.currentUserId) {
      const payload = {
        user_id: this.currentUserId,
        product_id: id,
      };
      this.webService.addWishlist(payload).subscribe({
        next: (res: any) => {
          if (res.status === 200 && res.data) {
            this.DataList = this.DataList.map((product: any) => {
              if (product.id === id) {
                product.wishlist = true;
              }
              return product;
            });
            this.utility.toastAlert('success', res.message);
            // this.fetchAllProduct();
          } else {
            this.utility.toastAlert('error', res.message);
          }
          this.isLoading = false;
        },
        error: (error: any) => {
          this.isLoading = false;
          this.utility.toastAlert(
            'error',
            error.message || 'An error occurred'
          );
        },
      });
    } else {
      this.router.navigate(['users/account/sign-in']);
    }
  }

  removeToWishlist(id: any): void {
    if (this.currentUserId) {
      this.webService
        .removeWishlistProduct(id, this.currentUserId)
        .subscribe((response: any) => {
          if (response.status === 200) {
            this.DataList = this.DataList.map((product: any) => {
              if (product.id === id) {
                product.wishlist = false;
              }
              return product;
            });
          } else {
            this.utility.toastAlert('error', response.message);
          }
        });
    } else {
      this.router.navigate(['users/account/sign-in']);
    }
  }
  getSubCatList(): void {
    this.webService
      .getSubCatById(this.categoryId)
      .subscribe((response: any) => {
        if (response.status === 200) {
          this.ResponseData = [];
        } else {
        }
      });
  }
  getAttrTermData(): void {
    const payload = {
      category_id: this.categoryId,
    };
    this.webService.getAttrTermData(payload).subscribe({
      next: (res: any) => {
        if (res.status === 200 && res.data) {
          this.attributeTerm = res.data;
        } else {
          this.attributeTerm = [];
        }
      },
      error: (error: any) => {
        this.utility.toastAlert('error', error.message || 'An error occurred');
      },
    });
  }

  openModal(data: any) {
    this.quantity = 1;
    this.isModalOpen = true;
    this.product = data;
    this.variationsCodeToFilter = data.variations.variations_code;
    this.termIdsToSelect = this.variationsCodeToFilter
      .split('-')
      .map((id) => parseInt(id, 10));
    this.webService
      .attributeWithVariationList(data.id, this.currentUserId)
      .subscribe((response: any) => {
        if (response.status === 200) {
          this.attrVariationDataList = response.data;
          this.variations = response.data.variations || [];
          this.setDefaultActiveTerms(this.termIdsToSelect);
          this.processProductDetails(
            this.attrVariationDataList,
            this.variationsCodeToFilter
          );
        } else {
          console.error('Product not found');
        }
        // this.isLoading = false;
      });
    this.isModalOpen = true;
  }
  setDefaultActiveTerms(termIdsToSelect: any): void {
    this.attrVariationDataList.attributeTermData.forEach(
      (attributeData: any) => {
        const matchingTerm = attributeData.terms.find((term: any) =>
          termIdsToSelect.includes(term.id)
        );
        if (matchingTerm) {
          this.activeTerms[attributeData.id] = matchingTerm.id;
        }
      }
    );
  }
  setActiveTerm(attributeId: number, termId: number): void {
    this.activeTerms[attributeId] = termId;
    this.updateVariationsCodeToFilter();
  }
  updateVariationsCodeToFilter(): void {
    const selectedTerms = Object.values(this.activeTerms);
    this.variationsCodeToFilter = selectedTerms.join('-');
    this.processProductDetails(
      this.attrVariationDataList,
      this.variationsCodeToFilter
    );
  }
  processProductDetails(response: any, variationsCodeToFilter: any): void {
    const selectedVariation = this.variations.find(
      (variation: any) => variation.variations_code === variationsCodeToFilter
    );
    if (selectedVariation) {
      this.variant_id = selectedVariation.id || 0;
      this.filteredVariationData = selectedVariation || '';
      this.price =
        selectedVariation.discount_price ||
        selectedVariation.variations_price ||
        '';
      this.firstVariationImagePath =
        selectedVariation.images?.[0]?.image_path ||
        this.attrVariationDataList.product_images?.[0]?.image_path ||
        this.attrVariationDataList.product_thumbnail ||
        '';
    } else {
      this.variant_id = 0;
      this.price =
        response.data.discount_price || response.data.selling_price || '';
      this.firstVariationImagePath = '';
    }
  }
  closeModal(event: any) {
    if (event.target.id === 'myModal' || event.target.className === 'close') {
      this.isModalOpen = false;
    }
  }
  stopPropagation(event: any) {
    event.stopPropagation();
  }
  plusMinusQuantity(action: string): void {
    if (action === 'plus') {
      this.quantity++;
    } else if (action === 'minus' && this.quantity > 1) {
      this.quantity--;
    }
  }

  classShow() {
    this.siteBarshowHide = true;
  }
  classHide() {
    this.siteBarshowHide = false;
  }
}
